import { useQuery } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'
import { Terminal } from 'interfaces/terminal'

const fetchTerminal = async (terminalId: string): Promise<Terminal> => {
  let response = await fetch(
    `${BASE_API_URL}/api/v4/phone_number_service/terminals/${terminalId}`,
    {
      method: API_METHODS.GET,
      headers: apiHeaders(store.getState()),
    }
  )

  response = handleErrors(response)
  return response.json()
}

const useTerminalDetail = (terminalId?: string) => {
  return useQuery(['terminal', terminalId], () => fetchTerminal(terminalId!), {
    enabled: !!terminalId,
    staleTime: 30000,
    retry: 2,
  })
}

export default useTerminalDetail
